import React from 'react';
import { useParams } from 'react-router';
import { bookingQuery } from './queries';

import Spinner from 'admin-components/components/Spinner';

import { useManagedQuery } from 'utils/managedHooks';

import QuoteConfirmation from './QuoteConfirmation';

const Index = () => {
  const { reference } = useParams();
  const { data, loading } = useManagedQuery(bookingQuery, {
    variables: { reference }
  });

  if (loading) {
    return <Spinner />;
  }

  return <QuoteConfirmation booking={data.booking} />;
};

export default Index;
